import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function FAQs() {
  return (
    <main className="main-content" id="MainContent">
      <div className="policy__container">
        <div className="policy__title">
          <h1>Frequently asked questions</h1>
        </div>
        <div className="policy__body">
          <div className="rte">
            <p>
              <strong>How long does production take?</strong><br />
              Made-to-order pieces generally require 6–8 weeks before dispatch.
              Ready-to-ship and vintage-inspired pieces may leave sooner; the
              order confirmation will include the applicable timing.
            </p>
            <p>
              <strong>Are product images exact?</strong><br />
              Images show the design, finish, and intended proportions. Natural
              stones, shell, and wood vary in color, pattern, and texture, so
              each finished piece will have its own character.
            </p>
            <p>
              <strong>How do I choose a size or finish?</strong><br />
              Available sizes and metal colors appear on each product page. If
              you need help before ordering, email{" "}
              <a href="mailto:wares@tuddlepetgoods.club">
                wares@tuddlepetgoods.club
              </a>.
            </p>
            <p>
              <strong>Can I request a custom piece?</strong><br />
              Yes. Send your preferred materials, size, budget range, and any
              reference ideas to our email. We will confirm feasibility and
              timing before accepting a custom order.
            </p>
            <p>
              <strong>Can made-to-order or customized items be returned?</strong><br />
              Customized, engraved, resized, altered, and made-to-order pieces
              are final sale unless they arrive damaged or incorrect. See our{" "}
              <Link to="/returns">Refund Policy</Link> for full details.
            </p>
            <p>
              <strong>How should I care for fine jewelry?</strong><br />
              Store pieces separately in a dry place. Avoid chemicals, perfume,
              pools, and impact. Clean metal and stones gently with a soft cloth;
              delicate shell, turquoise, and wood should not be soaked.
            </p>
            <p>
              <strong>Do international orders include duties and taxes?</strong><br />
              Unless checkout states otherwise, recipients are responsible for
              import duties, taxes, and customs charges assessed locally.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default FAQs;
